import { useState } from 'react';

function OnMenuToggle(initialState) {
  const [isOpen, toggleOpen] = useState(initialState || false);

  return [isOpen, toggleOpen];
}

export default OnMenuToggle;
